import { gql } from "@apollo/client";
import { useQueryWithSimpleErrorHandling } from "hooks";

export const DOCUMENT_SECURITY_QUERY = gql`
  query documentSecurity($documentId: Int!) {
    documentSecurity(documentId: $documentId) {
      access
    }
  }
`;

export function useDocumentSecurity(documentId) {
  const { data } = useQueryWithSimpleErrorHandling(DOCUMENT_SECURITY_QUERY, {
    variables: { documentId },
    skip: !documentId
  });

  return { access: data?.documentSecurity?.access };
}
